import { asText as asText$1 } from "@prismicio/richtext";
const asText = (richTextField, separator) => {
  if (richTextField) {
    return asText$1(richTextField, separator);
  } else {
    return null;
  }
};
export {
  asText
};
//# sourceMappingURL=asText.js.map
